import { moneySaid } from "@rally/agreed";
import { say } from "../../localization/say.ts";
import type { Turn, TurnRequest } from "../activity.ts";

export function requestPresentation(
  request: TurnRequest | null | undefined,
  requestedBy: string | null,
  expanded: boolean,
): { text: string; numberOfLines: 2 | undefined } | null {
  if (!request) return null;
  return {
    text: requestedBy ? say("agent.requestFrom")(requestedBy, request.text) : request.text,
    numberOfLines: expanded ? undefined : 2,
  };
}

export function turnCostPresentation(turn: Turn, active: boolean): string {
  if (active && turn.costKnown !== true) return say("agent.costPending");
  return moneySaid(active ? (turn.telemetrySpend ?? 0) : turn.spend);
}
